import React, { Component, ErrorInfo } from "react";
import { Alert, Button } from "@amzn/awsui-components-react-v3";
import { useLocation } from "react-router-dom";

interface State {
    hasError: boolean;
    error: Error | null;
}

class ErrorBoundary extends Component<{ children: React.ReactNode }, State> {
    state: State = { hasError: false, error: null };

    static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        console.error("ErrorBoundary caught:", error, info.componentStack);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: "2rem" }}>
                    <Alert type="error" header="Something went wrong">
                        An unexpected error occurred. Please try refreshing the page.
                    </Alert>
                    <div style={{ marginTop: "1rem" }}>
                        <Button onClick={() => window.location.reload()}>Refresh page</Button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export function ErrorBoundaryWithReset({ children }: { children: React.ReactNode }) {
    const location = useLocation();
    return <ErrorBoundary key={location.pathname}>{children}</ErrorBoundary>;
}

export default ErrorBoundary;
